module.exports = __webpack_public_path__ + "img/mail.0b967b6f.jpg";